import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const USER_SELECTOR_CLASS_NAME = 'UserSelector';
export const USER_SELECTOR_CLASS_SLOTS = ['root'] as const;

export type UserSelectorClassSlot = (typeof USER_SELECTOR_CLASS_SLOTS)[number];

export interface UserSelectorClasses {
	root: string;
}

export type UserSelectorClassKey = keyof UserSelectorClasses;

export const getUserSelectorUtilityClass = (slot: string) =>
	generateUtilityClass(USER_SELECTOR_CLASS_NAME, slot);

export const userSelectorClasses = generateUtilityClasses<
	keyof UserSelectorClasses
>(USER_SELECTOR_CLASS_NAME, ['root']);

export default userSelectorClasses;
